module.exports = __webpack_public_path__ + "static/media/menu-financing-blue.ce7f8e84.svg";